import { createSlice } from "@reduxjs/toolkit";

export type CartUIState = {
  isLoading: boolean;
};

const initialState: CartUIState = {
  isLoading: false,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {},
});

export default cartSlice.reducer;
